<template>
    <tr v-if="!showTransferForm && patient" :class="`${isDeleteRequested ? 'edit-row' : ''}`">
        <td><EmptyTextHandler :text="formatDateFromDate(patient.created)" /><br /></td>
        <td v-if="patient.firstName">
            <FormatName :first-name="patient.firstName" :last-name="patient.lastName" />
        </td>
        <td v-else>
            <small><i class="text-default">Not Available</i></small>
        </td>
        <td>
            <EmptyTextHandler :text="patient.agencyBranch" />
        </td>
        <td
            v-if="
                patient.serviceLine &&
                (patient.serviceLine === ApplicationEnum.AgencyCore ||
                    patient.serviceLine === ApplicationEnum.HomeCare ||
                    patient.serviceLine === ApplicationEnum.AxxessPalliative ||
                    patient.serviceLine === ApplicationEnum.AxxessHospice ||
                    patient.serviceLine === ApplicationEnum.AxxessHospiceFE)
            "
        >
            <EmptyTextHandler :text="getApplicableService(patient.serviceLine)" />
        </td>
        <td v-else>
            <small><i class="text-default">Not Available</i></small>
        </td>
        <td>
            <EmptyTextHandler :text="patient.referralType ? patient.referralType : 'External Referral'" />
        </td>
        <td><EmptyTextHandler :text="patient.dateOfBirth ? formatDateFromDate(patient.dateOfBirth) : null" /><br /></td>
        <td>
            <EmptyTextHandler :text="patient.branchName" />
        </td>
        <td class="text-center">
            <div class="big-text" v-if="patient?.comments?.length > 0" v-tooltip="{ title: patient.comments }">
                <i class="far fa-comment-dots text-info"></i>
            </div>
            <span v-else>
                <EmptyTextHandler :text="patient?.comments" />
            </span>
        </td>
        <td class="text-end" v-if="!isDeleteRequested">
            <button
                v-if="patient.status == null || listOfStatuses.includes(patient.status)"
                type="button"
                class="btn table-btn btn-outline-info me-1"
            >
                <i class="fas fa-edit" @click="toggleShowTransferForm()" />
            </button>
            <button
                v-if="patient.assetId != defaultAssetId"
                type="button"
                class="btn table-btn px-2 btn-outline-info au-target"
                v-tooltip="{ title: 'Download Document', placement: 'bottom' }"
                @click="downloadExternalRefrral()"
            >
                <i class="fas fa-paperclip icon-size"></i>
            </button>
            <button
                v-if="patient.isActive"
                type="button"
                class="btn table-btn btn-outline-danger"
                @click="confirmDeleteReferral()"
            >
                <i class="fas fa-trash-alt"></i>
            </button>
        </td>
        <td colspan="4" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                name="Referral"
                :isInProgress="isDeleteInProgress"
                :ok="deleteReferral"
                :cancel="cancelDeleteReferral"
            />
        </td>
    </tr>
    <template v-else>
        <tr class="transfer-form-row-one" v-if="patient">
            <td><EmptyTextHandler :text="formatDateFromDate(patient.created)" /><br /></td>
            <td v-if="patient.firstName">
                <FormatName :first-name="patient.firstName" :last-name="patient.lastName" />
                <br />
            </td>
            <td v-else>
                <small><i class="text-default">Not Available</i></small>
            </td>

            <td>
                <EmptyTextHandler :text="patient.agencyBranch" />
            </td>
            <td
                v-if="
                    patient.serviceLine &&
                    (patient.serviceLine === ApplicationEnum.AgencyCore ||
                        patient.serviceLine === ApplicationEnum.HomeCare ||
                        patient.serviceLine === ApplicationEnum.AxxessPalliative ||
                        patient.serviceLine === ApplicationEnum.AxxessHospice ||
                        patient.serviceLine === ApplicationEnum.AxxessHospiceFE)
                "
            >
                <EmptyTextHandler :text="getApplicableService(patient.serviceLine)" />
            </td>
            <td v-else>
                <small><i class="text-default">Not Available</i></small>
            </td>
            <td>
                <EmptyTextHandler :text="patient.referralType ? patient.referralType : 'External Referral'" />
            </td>
            <td>
                <EmptyTextHandler :text="patient.dateOfBirth ? formatDateFromDate(patient.dateOfBirth) : null" /><br />
            </td>
            <td>
                <EmptyTextHandler :text="patient.branchName" />
            </td>
            <td class="text-center">
                <div class="big-text" v-if="patient?.comments?.length > 0" v-tooltip="{ title: patient.comments }">
                    <i class="far fa-comment-dots text-info"></i>
                </div>
                <span v-else>
                    <EmptyTextHandler :text="patient?.comments" />
                </span>
            </td>
            <td class="text-end">
                <div class="big-text">
                    <i>Refer In Progress</i>
                </div>
            </td>
        </tr>
        <tr class="transfer-form-row-two edit-row">
            <td colspan="12" class="p-3 edit au-target">
                <FormSection>
                    <template #content>
                        <div class="row mx-2 d-flex justify-content-center px-3 pt-3">
                            <div class="form-group col-lg-2 ps-lg-0 me-lg-3 col-md-3">
                                <label for="task-name"> Refer To: </label>
                                <span class="text-danger">*</span>
                                <select
                                    id="task-name"
                                    class="form-select"
                                    v-model="referTo"
                                    @change="updateBranches(referTo.id)"
                                    @blur="v$.referTo.$touch"
                                >
                                    <option :value="null">Select Solution</option>
                                    <option
                                        v-for="(agency, index) of referableAgencyServices"
                                        :key="index"
                                        :value="agency"
                                    >
                                        <div v-show="agency.show">
                                            {{ agency.name }}
                                        </div>
                                    </option>
                                </select>
                                <span v-if="v$.referTo.$error" class="field-invalid">Field is required.</span>
                            </div>
                            <div class="form-group col-lg-2 col-md-3">
                                <label for="task-name">Branch: </label>
                                <span class="text-danger">*</span>

                                <select
                                    id="task-name"
                                    class="form-select"
                                    v-model="selectedBranch"
                                    :disabled="!referTo"
                                    @blur="v$.selectedBranch.$touch"
                                >
                                    <option value="null">Select Branch</option>

                                    <optgroup
                                        v-for="provider of providerList"
                                        :label="provider.name"
                                        :value="provider"
                                        :key="provider.name"
                                    >
                                        <option v-for="branch of provider.branches" :key="branch.name" :value="branch">
                                            {{ branch.name }}
                                        </option>
                                    </optgroup>
                                </select>
                                <span v-if="v$.selectedBranch.$error" class="field-invalid">Field is required.</span>
                            </div>
                        </div>
                        <div class="row mx-2 px-3 pb-2">
                            <div
                                :class="`form-group ps-lg-4 pe-lg-5 col-md-3 ${
                                    !isNonAdmit == true ? 'd-none' : 'd-block'
                                }`"
                            >
                                <label for="non-admit-date"> Non-Admit Date: </label>
                                <span class="text-danger">*</span>
                                <DatePicker :getDate="updateNonAdmitDate">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="nonAdmitDate"
                                            type="text"
                                            class="form-control"
                                            placeholder="MM/DD/YYYY"
                                            v-model="nonAdmitDate"
                                            autocomplete="off"
                                            :disabled="!isNonAdmit"
                                            @blur="v$.nonAdmitDate.$touch"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                                <span v-if="v$.nonAdmitDate.$error" class="field-invalid">Field is required.</span>
                            </div>
                            <div
                                :class="`form-group col-lg-2 ps-lg-0 col-md-3 ${
                                    !isNonAdmit == true ? 'd-none' : 'd-block'
                                }`"
                            >
                                <label for="non-admit-reason"> Non-Admit Reason: </label>
                                <span class="text-danger">*</span>
                                <select
                                    id="non-admit-reason"
                                    class="form-select"
                                    v-model="selectedNonAdmitReason"
                                    :disabled="!isNonAdmit"
                                    @blur="v$.nonAdmitDate.$touch"
                                >
                                    <option value="">Select Non-Admit Reason</option>
                                    <option
                                        v-for="nonAdmitReason of nonAdmitReasons"
                                        :key="nonAdmitReason.name"
                                        :value="nonAdmitReason"
                                    >
                                        {{ nonAdmitReason.name }}
                                    </option>
                                </select>
                                <span v-if="v$.selectedNonAdmitReason.$error" class="field-invalid"
                                    >Field is required.</span
                                >
                            </div>
                        </div>
                    </template>
                </FormSection>
                <div class="text-center pt-3 pb-2">
                    <button
                        type="button"
                        class="btn btn-primary btn-md au-target"
                        @click="convertToRefer()"
                        au-target-id="2039"
                    >
                        Refer
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-secondary btn-md ms-2 au-target"
                        @click="closeNonAdmitForm()"
                        au-target-id="2040"
                    >
                        Cancel
                    </button>
                </div>
            </td>
        </tr>
    </template>
</template>

<script lang="ts" src="./CreateExternalReferralRow.ts"></script>
